export default "__VITE_ASSET__D4CpErJk__"